import { portalTierPricesReducer } from './portalTierPrices.reducer'
export * from './portalTierPrices.types'
export * from './portalTierPrices.actions'
export * from './portalTierPrices.thunks'

export default portalTierPricesReducer
